import { MEDIA_LIST_PAGE, MEDIA_CLASSIFY_ID, MEDIA_STATUS_ID, USER_STATUS_ID, IS_ADMIN} from '../mutationsType'

const mutations = {
    [MEDIA_LIST_PAGE] (state, payload) {
        state.mediaListPage = payload
    },
    [MEDIA_CLASSIFY_ID] (state, payload) {
        state.mediaClassifyId = payload
    },
    [MEDIA_STATUS_ID] (state, payload) {
        state.mediaStatusId = payload
    },
    [USER_STATUS_ID] (state, payload) {
        state.statusId = payload
    },
    [IS_ADMIN] (state, payload) {
        state.isAdmin = payload
    }
}

const actions = {
    [MEDIA_LIST_PAGE] ({ commit }, payload ) {
        commit(MEDIA_LIST_PAGE, payload)
    },
    [MEDIA_CLASSIFY_ID] ({ commit }, payload ) {
        commit(MEDIA_CLASSIFY_ID, payload)
    },
    [MEDIA_STATUS_ID] ({ commit }, payload ) {
        commit(MEDIA_STATUS_ID, payload)
    },
    [USER_STATUS_ID] ({ commit }, payload) {
        commit(USER_STATUS_ID, payload)
    }
}

const getters = {
    mediaListPage: state => state.mediaListPage,
    mediaClassifyId: state => state.mediaClassifyId,
    mediaStatusId: state => state.mediaStatusId,
    statusId: state => state.statusId,
    isAdmin: state => state.isAdmin
}

export default function createMediaModule () {
    return {
        state: {
            // 媒体列表的页码
            mediaListPage: 1,
            // 媒体页分类id
            mediaClassifyId: 0,
            // 媒体页分类id
            mediaStatusId: -1,
            // 媒体页分类id
            statusId: -1
        },
        mutations,
        actions,
        getters
    }
}